//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { PrimaryLinkButton } from '@components/atoms/button/Button';
import {
  FilterOption,
  FilterValue,
} from '@components/media-filters/filterSectionModels';

interface ClearSelectionButtonProps<T extends FilterValue> {
  handleClearSection: (options: FilterOption<T>[]) => void;
  options: FilterOption<T>[];
}

export const ClearSelectionButton = <T extends FilterValue>({
  handleClearSection,
  options,
}: ClearSelectionButtonProps<T>) => {
  return (
    <PrimaryLinkButton
      isDisabled={!options.some(({ isSelected }) => isSelected)}
      onClick={() =>
        handleClearSection(
          options.map((option) => ({
            ...option,
            isSelected: false,
          })),
        )
      }
    >
      Clear Selection
    </PrimaryLinkButton>
  );
};
